/**
 * @generated SignedSource<<c6b4455290a2bbfd3a892a9c45c72076>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CourseVisibility = "MEMBER_ONLY" | "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
export type SpaceVisibility = "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type bottomTabs_club$data = {
  readonly communityEnabled: string | null | undefined;
  readonly coursePage: {
    readonly categories: ReadonlyArray<{
      readonly courses: ReadonlyArray<{
        readonly canView: boolean;
        readonly visibility: CourseVisibility;
      }>;
    }>;
    readonly id: string;
  };
  readonly coursesEnabled: string | null | undefined;
  readonly events: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
  };
  readonly eventsEnabled: string | null | undefined;
  readonly groups: ReadonlyArray<{
    readonly spaces: ReadonlyArray<{
      readonly isMember: boolean;
      readonly visibility: SpaceVisibility;
    }>;
  }>;
  readonly id: string;
  readonly rankingEnabled: string | null | undefined;
  readonly " $fragmentType": "bottomTabs_club";
};
export type bottomTabs_club$key = {
  readonly " $data"?: bottomTabs_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"bottomTabs_club">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "bottomTabs_club",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "communityEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "COMMUNITY_ENABLED"
        }
      ],
      "kind": "ScalarField",
      "name": "configuration",
      "storageKey": "configuration(key:\"COMMUNITY_ENABLED\")"
    },
    {
      "alias": "coursesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "COURSES_ENABLED"
        }
      ],
      "kind": "ScalarField",
      "name": "configuration",
      "storageKey": "configuration(key:\"COURSES_ENABLED\")"
    },
    {
      "alias": "eventsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "EVENTS_ENABLED"
        }
      ],
      "kind": "ScalarField",
      "name": "configuration",
      "storageKey": "configuration(key:\"EVENTS_ENABLED\")"
    },
    {
      "alias": "rankingEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "LEADERBOARD"
        }
      ],
      "kind": "ScalarField",
      "name": "configuration",
      "storageKey": "configuration(key:\"LEADERBOARD\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "CHRONOLOGICAL"
        }
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "events(orderBy:\"CHRONOLOGICAL\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SpaceGroup",
      "kind": "LinkedField",
      "name": "groups",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "spaces",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMember",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CoursePage",
      "kind": "LinkedField",
      "name": "coursePage",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "CourseCategory",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "courses",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "canView",
                  "storageKey": null
                }
              ],
              "storageKey": "courses(status:\"ACTIVE\")"
            }
          ],
          "storageKey": "categories(status:\"ACTIVE\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};
})();

(node as any).hash = "3a95c430d3e6b078a4127889ce4d8731";

export default node;
